import { t } from '@lingui/core/macro'
import { Trans } from '@lingui/react/macro'
import { QueryBaseSchema } from '@pkg/api/query/QueryFilterSchema'
import { defineEntityConfig } from '@pkg/db/schema/EntityConfig'
import { ButtonLink } from '@pkg/ui/button'
import { LinkIndicatorIcon } from '@pkg/ui/common/icons'
import { FormattedNameAndAddress } from '@pkg/ui/formattedContent/NameAndAddress'
import { FaHouseUser } from 'react-icons/fa6'
import { z } from 'zod'
import { NursingHomeSchema } from './schema/NursingHome'

const label = t`Pflegeheim`

export const NursingHomeConfig = defineEntityConfig(() => ({
  schema: NursingHomeSchema,

  label,
  labelPlural: t`Pflegeheime`,

  icon: FaHouseUser,

  route: {
    list: '/pflegeheime',
    edit: '/pflegeheime/$id',
    new: '/pflegeheime/new',
  },

  relationSelectionColumns: [
    {
      key: 'nursingHome.name',
      title: label,
      sorter: true,
      render: (_, row) => <FormattedNameAndAddress name={row.name} address={row.address ?? undefined} />,
    },
    {
      title: t`Versorgungsbereich`,
      key: 'nursingHome.serviceArea',
      sorter: true,
      render: (_, record) => record.serviceArea,
    },
  ],

  indexColumns: [
    {
      key: 'nursingHome.name',
      title: label,
      fixed: 'start',
      sorter: true,
      render: (_, row) => (
        <FormattedNameAndAddress
          name={row.name}
          address={row.address ?? undefined}
          link={{ to: '/pflegeheime/$id', params: { id: row.id } }}
        />
      ),
    },
    {
      title: t`Versorgungsbereich`,
      key: 'nursingHome.serviceArea',
      sorter: true,
      render: (_, record) => record.serviceArea,
    },
    {
      key: 'actions',
      title: <Trans>Aktionen</Trans>,
      sorter: false,
      fixed: 'end',
      render: (_, row) => (
        <ButtonLink to="/pflegeheime/$id" params={{ id: row.id }} size="small" shape="round">
          <Trans>Anzeigen</Trans>
          <LinkIndicatorIcon />
        </ButtonLink>
      ),
    },
  ],

  search: {
    filterSchema: QueryBaseSchema.extend({
      sortBy: z
        .enum([
          'nursingHome.name',
          'nursingHome.address.streetAddress',
          'nursingHome.address.zipCode',
          'nursingHome.address.city',
          'nursingHome.serviceArea',
        ])
        .nullish(),
    }),
    sortableFields: ['name', 'serviceArea', 'createdAt'] as const,
    defaultSortBy: 'name',
    defaultSortOrder: 'asc',
  },

  format: {
    primary: val => val?.name,
  },
}))
